import React, { memo } from 'react';
import type { BoolFilterViewModel } from 'autogen/swagger/all';
import AlphabeticalHeader from '../../AlphabeticalHeader';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import OptionsFilteredBySearchQuery from '../../Search/OptionsFilteredBySearchQuery';
import BooleanFilterOption from './BooleanFilterOption';

const BooleanFilterMenu = ({
    model: {
        displayName,
        options,
        queryStringName,
        showSearch,
        attribute: { id }
    }
}: {
    model: BoolFilterViewModel;
}) => {
    const filterMenuId = id.toString();
    const { closeFilterMenu } = useFilterMenu(filterMenuId);
    const shouldDisplayAlphabeticalHeaders = options.length >= 50;

    if (showSearch) {
        return (
            <FilterMenuDrawer withSearch id={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
                <OptionsFilteredBySearchQuery options={options}>
                    {(optionsFilteredBySearch) => (
                        <>
                            {optionsFilteredBySearch.map((option) => (
                                <React.Fragment key={option.value}>
                                    {shouldDisplayAlphabeticalHeaders && <AlphabeticalHeader option={option} />}
                                    <BooleanFilterOption
                                        model={option}
                                        queryStringName={queryStringName}
                                        menuDisplayName={displayName}
                                    />
                                </React.Fragment>
                            ))}
                        </>
                    )}
                </OptionsFilteredBySearchQuery>
            </FilterMenuDrawer>
        );
    }

    return (
        <FilterMenuDrawer id={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
            {options.map((option) => (
                <BooleanFilterOption
                    key={option.value}
                    model={option}
                    queryStringName={queryStringName}
                    menuDisplayName={displayName}
                />
            ))}
        </FilterMenuDrawer>
    );
};

export default memo(BooleanFilterMenu);
